<template>
  <v-card class="my-3 rounded" :class="{'mt-0': step === 1}" outlined>
    <v-card-text class="pa-3">
      <v-row align="center" no-gutters>
        <v-col cols="auto" class="mr-4">
          <v-avatar :color="completed ? 'primary' : 'secondary'" size="32">
            <v-icon v-if="completed" dark small>mdi-check</v-icon>
            <span v-else class="white--text body-2">{{ step }}</span>
          </v-avatar>
        </v-col>
        <v-col>
          <span class="d-block mb-1 body-2 font-weight-medium text--secondary">{{ title }}</span>
          <span class="d-block mb-2 body-2 text--primary">{{ description }}</span>

          <!-- actions -->
          <v-chip v-if="completed" color="primary" outlined small><v-icon left small>mdi-check</v-icon>Completado</v-chip>
          <v-btn v-else color="primary" outlined small :ripple="false" @click="$emit('action')">Completar</v-btn>
          <!-- end actions -->
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ActivationChecklistItem',
  props: {
    step: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    completed: {
      type: Boolean,
      default: false
    }
  }
}
</script>
